import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getArtAuthor } from './redux/selectors';
import { fetchArtAuthor as fetchArtAuthorAction } from './redux/actions';
const mapStateToProps = (state, ownProps)=>({
        artAuthor: ownProps.artAuthor || getArtAuthor(state)
    });
const mapDispatchToProps = {
    fetchArtAuthor: fetchArtAuthorAction
};
function wrapComponent(Component) {
    // tslint:disable-next-line only-arrow-functions
    return function WrapperComponent(_param) {
        var { artImageSrc, artAuthor, artAuthorUsername, fetchArtAuthor } = _param, props = _object_without_properties(_param, [
            "artImageSrc",
            "artAuthor",
            "artAuthorUsername",
            "fetchArtAuthor"
        ]);
        // Load art author user data on the first render.
        // If we're not in production, use chris as the username to avoid
        // getting an error due to inexistent user data.
        useEffect(()=>{
            !artAuthor && fetchArtAuthor && artAuthorUsername && fetchArtAuthor({
                username: process.env.NODE_ENV === 'development' ? 'chris' : artAuthorUsername
            });
        });
        return /*#__PURE__*/ React.createElement(Component, _object_spread({
            artImageSrc: artImageSrc,
            artAuthor: artAuthor
        }, props));
    };
}
export default function withPopupArt(component) {
    return connect(mapStateToProps, mapDispatchToProps)(wrapComponent(component));
}
